<template>
  <Layout>
    <Header>
      <Menu mode="horizontal" theme="dark" active-name="home">
        <div class="layout-logo">
          <div>
            <img id="u294_img" src="../../assets/baiselogo.png"/>
          </div>
          <div>
            <img id="u292_img" src="../../assets/baise.png"/>
          </div>
        </div>
        <div class="layout-nav">
          <MenuItem name="home" to="/">首页</MenuItem>
          <MenuItem name="introduction" to="/introduction">企业介绍</MenuItem>
          <Submenu name="product">
            <span slot="title" class="submenu-title-wrapper">产品技术</span>
            <MenuItem name="page1" to="/product/bigData">大数据分析</MenuItem>
            <MenuItem name="page2" to="/product/machineVision">机器视觉</MenuItem>
            <MenuItem name="page3" to="/product/MedicalAI">医疗AI</MenuItem>
            <MenuItem name="page4" to="/product/knowledgeGraph">知识图谱</MenuItem>
            <MenuItem name="page5" to="/product/rulesEngine">规则引擎</MenuItem>
            <MenuItem name="page6" to="/product/intelligentDevice">智能设备</MenuItem>
            <MenuItem name="page7" to="/product/intelligencePlatform">智慧平台</MenuItem>
            <MenuItem name="page8" to="/product/machineLearning">机器学习</MenuItem>
          </Submenu>
          <MenuItem name="5" to="/newsInformation">新闻动态</MenuItem>
          <MenuItem name="6" to="/recruits">人才招聘</MenuItem>
          <MenuItem name="concact" to="/contact">联系我们</MenuItem>
        </div>
      </Menu>
    </Header>
  </Layout>
</template>

<script>
export default {
  name: 'i-header',
  components: {}
}
</script>

<style scoped>
  .layout-logo{
    border-radius: 3px;
    float: left;
    position: relative;
    top: 15px;
  }
  .layout-nav{
    width: 800px;
    left:648px;
    margin: 0 0 auto 648px;
    font-weight:bold;
  }
  #u294_img {
    position:absolute;
    left:390px;
    top:0px;
    width:44px;
    height:33px;
  }
  #u292_img {
    position:absolute;
    left:440px;
    top:0px;
    width:118px;
    height:34px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/Header.vue